import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import { selectListItems } from '../../../../../redux/library/selector';
import { useSelector } from 'react-redux';

export default function PlatformDBAServiceBasicInfoComponent ({id,dbas,selectedService,handleInnerFormChange}: any) {
  const libraryData = useSelector(selectListItems)
 
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
         {id=== '0' && 
        <InputContainer
       
                           label="DBA Name"
                           labelField="Name"
                           list={dbas}
                           onValueChange={(event: any, newValue: any) => {
                            handleInnerFormChange(
                              event.target.value,
                              'PlatformDBAId',
                            )
                           }}
                           optionName="Choose DBA"
                           type="select"
                           value={selectedService?.PlatformDBAId}
                           valueField="Id"
                       />}
        {id!== '0' && 
        <InputContainer
        isDisabled
                           label="DBA Name"
                           labelField="Name"
                           list={dbas}
                           onValueChange={(event: any, newValue: any) => {
                            handleInnerFormChange(
                              event.target.value,
                              'PlatformDBAId',
                            )
                           }}
                           optionName="Choose DBA"
                           type="select"
                           value={selectedService?.PlatformDBAId}
                           valueField="Id"
                       />}
           <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                )
              }}
              type="text"
              value={selectedService?.Name}
          />
          
         <InputContainer
              label="DisplayOrder"
              name="DisplayOrder"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'DisplayOrder',

                )
              }}
              type="number"
              value={selectedService?.DisplayOrder}
          />
          <InputContainer
              label="Remarks"
              name="Remarks"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Remarks',

                )
              }}
              type="text"
              value={selectedService?.Remarks}
          />
        
         <div className='col-span-full'>
        <InputContainer
       
            label="Description"
            name="Description"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event,
                'Description',

              )
            }}
              type="rte"
            value={selectedService?.Description}
        /></div>
          
        </div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}